// ============================================================================
// CANONICAL HTML VIEWER REPOSITORY
// ARQUIVO: src/pages/portal/CanonicalHtmlViewerRepository.js
// RESPONSABILIDADE: Isolar todas as chamadas Firestore do CanonicalHtmlViewer.
// ============================================================================

import { collection, doc, getDoc, getDocs, limit, query, where } from 'firebase/firestore';
import { db } from '../../shared/api/firebase/config';
import { FS } from '../../shared/constants/firestorePaths';

export const findPortalClientByEmail = async (appId, email) => {
  const safeEmail = String(email || '').trim();
  if (!safeEmail) return null;
  const hits = [];

  try {
    const ref = collection(db, 'clients');
    const snap = await getDocs(query(ref, where('email', '==', safeEmail), limit(1)));
    if (!snap.empty) {
      const found = snap.docs[0];
      hits.push({ id: found.id, ...(found.data() || {}) });
    }
  } catch (e) { void e; }

  if (hits.length === 0 && String(appId || '').trim()) {
    const ref = collection(db, ...FS.clients(appId));
    const probes = [safeEmail];
    const lower = safeEmail.toLowerCase();
    if (lower !== safeEmail) probes.push(lower);
    for (const probe of probes) {
      try {
        const snap = await getDocs(query(ref, where('contact.email', '==', probe), limit(1)));
        if (!snap.empty) {
          const found = snap.docs[0];
          hits.push({ id: found.id, ...(found.data() || {}) });
          break;
        }
      } catch (e) { void e; }
    }
  }

  return hits[0] || null;
};

export const fetchDocumentById = async (appId, documentId) => {
  const refs = [];
  if (String(appId || '').trim()) refs.push(doc(db, ...FS.documents(appId), documentId));
  refs.push(doc(db, 'documents', documentId));

  for (const candidateRef of refs) {
    try {
      const snap = await getDoc(candidateRef);
      if (!snap.exists()) continue;
      return snap.data() || {};
    } catch (e) { void e; }
  }
  return null;
};
